module.exports = __webpack_public_path__ + "static/media/1.793eb344.jpg";